import { render, staticRenderFns } from "./Proveedores.vue?vue&type=template&id=77576cf5&"
import script from "./Proveedores.vue?vue&type=script&lang=js&"
export * from "./Proveedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports